<div class="content nopad dark">
	<div class="row">
		<div class="col-lg-12">
			<div class="flightmap-container">
				<div id="flightmap" [ngClass]="'speed-' + viewer?.speed"></div>
				<div *ngIf="loading || error" class="flightmap-overlay">
					<div *ngIf="loading">
						<div class="logo-spin" [class.light]="light"></div>
						Loading...
					</div>
					<div *ngIf="error">
						<div class="logo-spin stopped" [class.light]="light"></div>
						{{error}}
					</div>
				</div>
			</div>
		</div>
	</div>
	<div [hidden]="error" class="row">
		<div class="col-lg-12">
			<app-dvs-chart #scrubberChart [options]="scrubberOptions" [height]="'150px'" [timezone]="fleet ? fleet.time_offset_hours : 0" [short]="true"></app-dvs-chart>
		</div>
	</div>

	<div *ngIf="!loading" class="content">
		<div class="row">
			<div *ngIf="pathFrame && pathFrame.ts" class="col-lg-6">
				<div class="flat-indicator">
					<span class="label">Timestamp:</span> {{ (pathFrame.ts * 1000) | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0) }}
				</div>
			</div>
			<div *ngIf="pathFrame && pathFrame.regime_id" class="col-lg-6">
				<div class="flat-indicator">
					<span class="label">Regime:</span> {{ lookupRegime(pathFrame.regime_id) }}
				</div>
			</div>
		</div>
		<div class="row">
			<ng-container *ngFor="let param of stateParams">
				<app-indicator-number *ngIf="param.selected" [frame]="pathFrame" [field]="param.name.toLowerCase()" [label]="param.name" [units]="param.units"></app-indicator-number>
			</ng-container>
		</div>
		<div class="row">
			<button (click)="ChooseIndicators()" class="btn btn-info btn-sm mx-auto">Choose indicators</button>
		</div>
	</div>
</div>

<ng-template #indicatorModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title">Choose indicators</h4>
		<button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="container">
			<div class="row">
				<ng-container *ngFor="let prop of selectorParams">
					<div class="col-sm-6 col-lg-4">
						<label>
							<input type="checkbox" [(ngModel)]="prop.selected"> {{prop.name}}
						</label>
					</div>
				</ng-container>
			</div>
		</div>
		<button (click)="ApplyIndicators()" class="btn btn-success btn-sm">Apply selections</button>
	</div>
</ng-template>